/**
 * 系统管理  角色管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '../charts/statistics' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.roleNo" placeholder="输入id"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="shopId" label="店铺id" width="80">
      </el-table-column>
	  <el-table-column  prop="roleName" label="地址" width="150">
	  </el-table-column>
      <el-table-column  prop="roleNo" label="电话号码" width="100">
      </el-table-column>
      <el-table-column sortable prop="editTime" label="结算金额" width="80">
      </el-table-column>
      <el-table-column  prop="editUser" label="收款码" width="400">
         <template slot-scope="scope">
           <img style="width: 50%; height: auto;"  v-for="item in scope.row.img" :src="item" />
         </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="50">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="menuAccess(scope.$index, scope.row.shopId)">结算</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
import {
  getShopAccount,
  submitShopAccount,
  roleSave,
  roleDelete,
  rolePwd,
  RoleRightTree,
  RoleRightSave,
  PictureServer
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      menuAccessshow: false, //控制数据权限显示与隐藏
      title: '添加',
      editForm: {
        roleId: '',
        systemNo: '',
        roleNo: '',
        roleName: '',
        token: localStorage.getItem('logintoken')
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      isChecked1:false,
      isChecked3:false,
      listData: [], //用户数据
      // 数据权限
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  watch: {},
  created() {
    this.getdata(this.formInline)
  },

  methods: {
    // 获取角色列表
    getdata(parameter) {
      // 模拟数据
      let res = {
        code: 0,
        msg: null,
        count: 6,
        data: []
      }
      this.loading = false
      this.listData = res.data
      // 分页赋值
      this.pageparm.currentPage = this.formInline.page
      this.pageparm.pageSize = this.formInline.limit
      this.pageparm.total = res.count
      // 模拟数据结束
      getShopAccount()
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            for(var i=0;i<res.data.shop.length;i++){
              for(var j=0;j<res.data.verification.length;j++){
                console.log(res.data.shop[i][0],res.data.verification[j][0])
                if(res.data.shop[i][0]==res.data.verification[j][0]){
                  this.listData.push({
                    shopId:res.data.shop[i][0],
                    editTime:((res.data.shop[i][1])/100).toFixed(2),
                    roleName:res.data.verification[j][1],
                    roleNo:res.data.verification[j][2],
                    img:[PictureServer.Info+res.data.verification[j][3],PictureServer.Info+res.data.verification[j][4]]
                  })
                  break
                }
              }
              }
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('获取角色列表失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    // 数据权限
    menuAccess(index,id) {
      this.$confirm('确定要结算吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        submitShopAccount(id).then(res => {
          this.editFormVisible = false
          this.loading = false
          if (res.state == 200) {
            this.$message({
              type: 'success',
              message: '成功！'
            })
            this.listData.splice(index,1)
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.cell{
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/Role.vue